<form [formGroup]="formData">
  <div class="form-group">
    <h5 for="">Push orders from STANDARD Delivery Client Invoices to OMS</h5>
    <div>
      <mat-checkbox formControlName="invoice_push_to_oms">
        Enable <b>Pushing STANDARD Delivery Client Invoices</b> to OMS
      </mat-checkbox>
      <small class="text-warning"> This will create an order in selected OMS</small>
    </div>
    <div class="shipstation-store-id" *ngIf="shouldPushInvoiceToOms">
      <div class="row my-3">
        <div class="col-6">
          <div class="form-group">
            <label for="">Select OMS to Push Orders To</label>
            <lum-app-integration-account-control
              [appAccountType]="supportedAppAccountType"
              formControlName="invoice_push_to_oms_account_id"
            ></lum-app-integration-account-control>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group" *ngIf="selectedAppIntegrationAccountId">
            <label for="">Select OMS Store</label>
            <lum-app-integration-account-oms-store-control
              [appIntegrationAccountId]="selectedAppIntegrationAccountId"
              [excludeUsedOmsStoreIds]="false"
              formControlName="invoice_push_to_oms_store_id"
            ></lum-app-integration-account-oms-store-control>
          </div>
        </div>

        <div class="col-12">
          <mat-checkbox formControlName="invoice_push_to_oms_automatically">
            Push client invoices to OMS automatically
          </mat-checkbox>
          <small class="text-warning">
            Please select the timing to push invoices automatically.</small
          >
        </div>
        <div class="col-12" *ngIf="shouldPushInvoiceToOmsAutomatically">
          <select
            name="shipstation-store-id"
            id="shipstation-store-id"
            class="form-control"
            formControlName="invoice_push_to_oms_timing"
          >
            <option value="immediately">Immediately</option>
            <option value="after_first_payment">After First Payment</option>
            <option value="after_full_payment">After Full Payment</option>
          </select>
        </div>
      </div>

      <lum-setting-warehouse-group-push-order></lum-setting-warehouse-group-push-order>
    </div>
  </div>
</form>
